import { ConfirmDialog } from '@components/tailwind-components/ConfirmDialog';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

// Shown before the first edit of a question that was already handled from another
// context. Mirrors the confirmation the conversation checklist raises for the same
// case, so re-optimizing is always a deliberate act rather than a stray click.
export const ConversationReviewReoptimizePrompt: React.FC<Props> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      isOpen={isOpen}
      icon='warning'
      title={t('general.modal.confirm-action')}
      description={t('train-ai.reoptimize.message')}
      onClose={onCancel}
      buttons={[
        {
          label: t('general.buttons.confirm'),
          styling: 'primary',
          onClick: onConfirm,
        },
        {
          label: t('general.buttons.cancel'),
          styling: 'cancel',
          onClick: onCancel,
        },
      ]}
    />
  );
};
